import { getLessonDetail } from "@/services/lessonsService";
import { useQuery } from "@tanstack/react-query";

export const useLessonDetail = ({
  id,
  enabled,
}: {
  id: number | undefined;
  enabled: boolean;
}) => {
  const { data, isLoading, refetch, error } = useQuery({
    queryKey: ["lesson-detail", Number(id)],
    queryFn: () => getLessonDetail(Number(id)),
    enabled: enabled || false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    refetch,
    error,
  };
};
